export default __webpack_public_path__ + "static/media/groovy.e8882a35.png";